import { createSelector, createFeatureSelector } from '@ngrx/store';
import * as creditorDetailsReducers from '../reducers/creditor-details.reducers';


export const selectDetailsWidgetData = createFeatureSelector<creditorDetailsReducers.CreditorDetailsState>('CreditorDetails');

const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = creditorDetailsReducers.adapter.getSelectors(selectDetailsWidgetData);

export const selectEntityByWidgetId = (widgetId: number) =>
  createSelector(selectEntities, (entities) => entities[widgetId]);

export const isLoading = (widgetId: number) =>
  createSelector(selectEntityByWidgetId(widgetId),
    (entity: creditorDetailsReducers.CreditorDetailsInstance) => {
      return entity && entity.loading;
    }
  );

export const getCreditorDetails = (widgetId: number) =>
  createSelector(selectEntityByWidgetId(widgetId),
    (entity: creditorDetailsReducers.CreditorDetailsInstance) => {
      return entity.details;
    }
  );
